// src/features/help/useHelpTokens.ts

import { useMemo } from 'react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { ExtPlatConfig } from '@/shared/utils/extplatBrandConfig';
import { HELP_DIRECT_BRAND_NAME, HELP_SUPPORT_EMAIL } from './helpConstants';
import type { HelpTokens } from './HelpContentUtils';

/**
 * Brand-aware values for {{brandName}} / {{supportContact}} (plan §5.7).
 * Reseller end-customers must never see the direct brand or its support email.
 */
export function useHelpTokens(): HelpTokens {
  const { selectedCustomer } = useAuth();
  const reseller = selectedCustomer?.cfg.reseller;
  const isReseller = ExtPlatConfig.isReseller(reseller);
  const label = selectedCustomer?.cfg.label;
  const supportUri = reseller?.supportUri;
  const supportPhone = reseller?.supportPhone;

  return useMemo(() => {
    if (isReseller) {
      return {
        brandName: label || 'your provider',
        supportContact: supportUri || supportPhone || 'your account administrator',
      };
    }
    return { brandName: HELP_DIRECT_BRAND_NAME, supportContact: HELP_SUPPORT_EMAIL };
  }, [isReseller, label, supportUri, supportPhone]);
}
